import React from "react";
import "./index.scss";
import CustomSearchInput from "@components/CustomSearchInput/CustomSearchInput";
const CustomHeader = ({ title, dataLength, onSearch, tabSections }) => {
  const dataLengthTitle = dataLength ? ` (${dataLength})` : "";

  return (
    <div className="header-container">
      <div className="header-top-container">
        <div className="header-title">
          {title}
          {dataLengthTitle}
        </div>
        <CustomSearchInput onSearch={onSearch} />
      </div>
      {tabSections?.length > 0 && (
        <div>
          {tabSections.map((tab, index) => (
            <div key={index} className="tab-section">
              {tab}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomHeader;
